// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------

import React, { useState, useEffect, useMemo } from 'react';
// import { useQuery } from '@tanstack/react-query';
// import ApiGo from '../../../actions/ApiGo';
import PopUpNavBar from '../../navBar/PopUpNavBar';
import HISAutoBed from './HISAutoBed/HISAutoBed';
import HISAutoRoll from './HISAutoRoll/HISAutoRoll';
import HISBedState from './HISBedState/HISBedState';
import HISSE from './HISSE/HISSE';
import HISVital from './HISVital/HISVital';
import './_HistoryRecord.scss';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';
import common_images from '../../../comm_imgs';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_HIS_DATE, ADD_TIME_START, ADD_TIME_END, ADD_HIS_ALERTS } from '../../../stores/reducer_HistoryData';
import HISDiaper from './HISDiaper/HISDiaper';
// import Angle from './HISAutoBed/Angle';
import HISBedStateMR from './HISBedState/HISBedStateMR';
import HISBedStateDR from './HISBedState/HISBedStateDR';
import HISVitalRow from './HISVital/VitalRow';
import HISVitalAbnormal from './HISVital/VitalRowAbnormal';
import HISDiaperAbnormal from './HISDiaper/HISDiaperAbnormal';
import ConfigHandler from '../../../actions/ConfigHandler';
// import HISEpWeight from './HISEpmed/HISEpWeight';
// import HISEpBloodPressure from './HISEpmed/HISEpBloodPressure';
// import HISEpBed from './HISEpmed/HISEpBed';
// import { HISEpWeightChart } from './HISEpmed/HISEpWeightChart';
import Account from '../../../actions/Account';
import PopUpNavBarMobile from '../../navBar/PopUpNavBarMobile';
import HISSEDemo from './HISSE/HISSEDemo';
import HisMobility, { convertTimestamp } from './HisMobility/HisMobility';
import HisMovenment from './HisMobility/HisMovenment';
import HisSixIndex, { isAllDataEmpty } from './HisMobility/HisSixIndex';
import HISSEChart from './HISSE/HISSEChart';
import { useAppSelector } from '../../../stores/hooks';
import ApiGo_TS from '../../../actions/ApiGo_TS';
import { ADD_RESPONSE } from '../../../stores/reducer_add';
import HisMobilityByDays from './HisMobility/HisMobilityByDays';

const HistoryRecord = (props) => {
  const { t } = useTranslation();
  // 先配對 bed id 和 residents
  const [page, setPage] = useState();
  // 日期
  const timestamp_now = new Date().getTime();
  const [activityData, setActivityData] = useState(null);
  const [days_open, setDays_open] = useState('TODAY'); // 用於判斷多日開關
  const [daySwitch, setDaySwitch] = useState('all');
  //功能開關切換
  const isBED = true;
  const isSLEEP = true;
  const isMOBILITY = ConfigHandler.isMOBILITY;
  const isVITAL = ConfigHandler.isVital;
  // ------------------ redux ------------------
  const dispatch = useDispatch();
  const store = useSelector((state) => state.store_hisPage);
  const store_timestamp = useAppSelector((state) => state.store_historyData.timestamp);

  useEffect(() => {
    // 紀錄 & 清除 date
    // let to12OCLock = timestamp_now - (timestamp_now%86400000) - 28800000
    let to12OCLock = timestamp_now - (timestamp_now % 86400000) - 43200000;
    dispatch(ADD_HIS_DATE(timestamp_now));
    dispatch(ADD_TIME_START(to12OCLock));
    dispatch(ADD_TIME_END(to12OCLock + 43200000));
    return () => {
      dispatch(ADD_HIS_DATE(timestamp_now));
      dispatch(ADD_TIME_START(timestamp_now));
      dispatch(ADD_TIME_END(timestamp_now));
    };
  }, []);
  // ------------------ redux ------------------
  // 時間轉換 2024-05-27;
  const convertedTimestamp = useMemo(() => (store_timestamp ? convertTimestampToDateString(store_timestamp) : null), [store_timestamp]);

  // const { data: activityData, isSuccess } = useQuery({
  //   queryKey: ["mobilityChartData", props.data.id, convertedTimestamp],
  //   queryFn:  () => fetchData(),
  //   enabled: !!convertedTimestamp && is_kmtth,
  // });
  // useEffect(() => {
  //   if (isSuccess) {
  //     loadData(activityData);
  //   }else{
  //     loadData()
  //   }
  // }, [isSuccess, store, store_timestamp]);

  /////////////////////////////////Old/////////////////////////////////////////////
  useEffect(() => {
    checkAndLoadData();
  }, [store, store_timestamp, days_open, daySwitch]);

  //比對資料是否有更新
  const checkAndLoadData = async () => {
    const fetchedActivityData = await fetchData();
    if (!isEqual(fetchedActivityData, activityData)) {
      setActivityData(fetchedActivityData);
      loadData(fetchedActivityData);
    } else {
      loadData(activityData);
    }
  };
  /////////////////////////////////Old/////////////////////////////////////////////
  //取得4項指標，用props傳入
  const loadData = (data) => {
    if (!ConfigHandler.isShowEP()) {
      let caseIndex = 0;

      if (isBED) {
        if (store.page === caseIndex) {
          if (store.dropDown === 0) setPage(<HISBedState data={props.data} />);
          if (store.dropDown === 1) setPage(<HISBedStateDR data={props.data} />);
          if (store.dropDown === 2) setPage(<HISBedStateMR data={props.data} />);
          return;
        }
        caseIndex++;
      }

      if (isVITAL) {
        if (store.page === caseIndex) {
          if (store.dropDown === 0) setPage(<HISVital data={props.data} />);
          if (store.dropDown === 1) setPage(<HISVitalRow data={props.data} />);
          if (store.dropDown === 2) setPage(<HISVitalAbnormal data={props.data} />);
          return;
        }
        caseIndex++;
      }

      if (isSLEEP) {
        if (store.page === caseIndex) {
          if (store.dropDown === 0) setPage(<HISSE data={props.data} />);
          if (store.dropDown === 1) setPage(<HISSEChart data={props.data} />);
          if (store.dropDown === 2) setPage(<HISSEDemo data={props.data} />);
          return;
        }
        caseIndex++;
      }

      if (isMOBILITY) {
        if (store.page === caseIndex) {
          if (store.dropDown === 0) setPage(<HisMobility data={props.data} activityData={data} days_open={days_open} setDays_open={setDays_open} daySwitch={daySwitch} setDaySwitch={setDaySwitch} />);
          if (store.dropDown === 1) setPage(<HisSixIndex data={props.data} activityData={data} days_open={days_open} setDays_open={setDays_open}/>);
          if (store.dropDown === 2) setPage(<HisMovenment data={props.data} days_open={days_open} setDays_open={setDays_open} daySwitch={daySwitch} setDaySwitch={setDaySwitch} />);
          return;
        }
      }
    }
  };

  // //更新版mobilityData
  const fetchData = async () => {
    if (store_timestamp.length === 0 || !isMOBILITY || days_open === 'FORDAYS') return;
    const dateTime = convertTimestamp(store_timestamp);
    try {
      const res = await ApiGo_TS.getMobilityData(props.data.id, dateTime);
      const isDataEmpty = isAllDataEmpty(res);
      if (isDataEmpty && store.page === 3 && (store.dropDown === 0 || store.dropDown === 2)) {
        dispatch(ADD_RESPONSE({ status: 404, statusText: 'Not Found', type: 'hisRec_no_data' }));
        dispatch(ADD_HIS_ALERTS([]));
      }
      return { isOldData: false, newResult: res, oldResult: [] };
    } catch (error) {
      console.log('error', error);
    }
  };
  return (
    <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-d-c fx-ccc bg-black" onClick={props.hide}>
      <div className={`layout-history rotateAll fx-d-c ${Account.isMobile() ? '' : 'pad-30 l r'}`} onClick={(e) => e.stopPropagation()}>
        {Account.isMobileOrTablet() ? (
          <PopUpNavBarMobile hide={props.hide} isShow={[true, true, true, ConfigHandler.isShowAIDC(), ConfigHandler.isShowAIDC(), ConfigHandler.isShowEP()]} />
        ) : (
          <PopUpNavBar
            hide={props.hide}
            isShow={[
              true,
              true,
              true,
              true,
              // ConfigHandler.isShowAIDC(),
              ConfigHandler.isShowAIDC(),
              ConfigHandler.isShowEP(),
            ]}
          />
        )}
        <div className="h-85 fx-d-c w-100">{page}</div>
      </div>
    </div>
  );
};
export default HistoryRecord;

const convertTimestampToDateString = (timestamp) => {
  const date = new Date(Number(timestamp));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
